/**
 * A jelszószabály a felületen - ugyanaz, mint a backend PasswordPolicy-je
 * (ClubTracker.Core/Auth/PasswordPolicy.cs): legalább 8 karakter, betű és szám.
 * A közismert jelszavakat a szerver utasítja el.
 */
export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_HINT = 'Legalább 8 karakter, betű és szám is legyen benne.';

/** A szabálynak meg nem felelő jelszónál a hibaüzenet, különben null. */
export const validatePassword = (password: string): string | null =>
  password.length < PASSWORD_MIN_LENGTH || !/\p{L}/u.test(password) || !/\d/.test(password)
    ? 'A jelszó legalább 8 karakter legyen, és betű és szám is legyen benne.'
    : null;
